import {
  Dimensions,
  FlatList,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {jieduan} from './sceneType';
import Modal from 'react-native-modal';
import React, {useEffect} from 'react';
import {createStyles} from '../../../../utils/createStyles';

interface YearListModalProps {
  visible: boolean;
  onBackdropPress: () => void;
  year: number;
  changeYear: (year: number) => void;
}

const YearListModal: React.FC<YearListModalProps> = ({
  visible,
  onBackdropPress,
  changeYear,
  year,
}) => {
  const deviceWidth = Dimensions.get('window').width;
  const deviceHeight =
    Platform.OS === 'ios'
      ? Dimensions.get('window').height
      : require('react-native-extra-dimensions-android').get(
          'REAL_WINDOW_HEIGHT',
        );
  const yearList = jieduan.years;
  useEffect(() => {
    if (visible) {
      console.log('112', year);
      setCurrentYear(year ? year : 9999);
    }
  }, [visible]);
  const [currentYear, setCurrentYear] = React.useState<number>(9999);
  return (
    <Modal
      style={{justifyContent: 'center', alignItems: 'center'}}
      isVisible={visible}
      animationIn={'bounceIn'}
      animationOut={'bounceOut'}
      onBackdropPress={onBackdropPress}
      deviceHeight={deviceHeight}
      deviceWidth={deviceWidth}>
      <View style={styles.ModalBox}>
        <View style={styles.ModalBoxMain}>
          <FlatList
            style={{width: '100%'}}
            data={yearList}
            renderItem={({item}) => {
              return (
                <TouchableOpacity
                  onPress={() => {
                    setCurrentYear(item.id);
                  }}
                  style={styles.ModalBoxMainItem}>
                  <Text
                    style={[
                      styles.ModalBoxMainItemText,
                      item.id === currentYear && {color: '#6658FF'},
                    ]}>
                    {item.name}
                  </Text>
                </TouchableOpacity>
              );
            }}
          />
        </View>
        <View style={styles.ModalBoxBtns}>
          <TouchableOpacity
            onPress={onBackdropPress}
            style={styles.ModalBoxBtnsItem}>
            <Text style={[styles.ModalBoxBtnsItemText, {color: '#6658FF'}]}>
              关闭
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              changeYear(currentYear);
              onBackdropPress();
            }}
            style={[styles.ModalBoxBtnsItem, {backgroundColor: '#6658FF'}]}>
            <Text style={[styles.ModalBoxBtnsItemText, {color: '#fff'}]}>
              确定
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};
const styles = createStyles({
  ModalBox: {
    width: '25.35rem',
    height: '31rem',
    backgroundColor: '#FFFFFF',
    borderRadius: '1rem',
    paddingHorizontal: '1.25rem',
    paddingVertical: '0.8rem',
  },
  ModalBoxMain: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1.95rem',
  },
  ModalBoxMainItem: {
    width: '100%',
    marginBottom: '1.85rem',
    alignItems: 'center',
  },
  ModalBoxMainItemText: {
    fontSize: '1.4rem',
    color: '#3D3D3D',
  },
  ModalBoxBtns: {
    width: '100%',
    height: '4rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '1.5rem',
  },
  ModalBoxBtnsItem: {
    width: '10.7rem',
    height: '4rem',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E2E2FF',
    borderRadius: '0.8rem',
  },
  ModalBoxBtnsItemText: {
    fontSize: '1.4rem',
  },
});
export default YearListModal;
